import React, { useState } from "react";
import Modal from "react-bootstrap/Modal";
import Card from "react-bootstrap/Card";
import Nav from "react-bootstrap/Nav";
import { CardBody, CardHeader } from "react-bootstrap";
import Klantgegevens from "./klantgegevens";
import EindkKlantgegevens from "./eindklantgegevens";
import SettingsOptions from "./settingsOptions";
import { getTranslations } from "../Shared/translations";
import "./settings.css";
import "./shared.css";

interface SettingsProps {
  visible: string;
  onDataChange: (t: any) => any;
}

const Settings: React.FC<SettingsProps> = ({ visible, onDataChange }) => {
  const [selectedView, setSelectedView] = useState<string>("Installateur");
  const t = getTranslations();
  const handleClose = () => {
    onDataChange({ settings: "hidden" });
  };

  const handleSelect = (eventKey: string | null) => {
    if (eventKey) setSelectedView(eventKey);
  };

  return (
    <Modal show={visible === "settings"} dialogClassName="modal_settings">
      <Modal.Header
        closeButton
        onClick={handleClose}
        className="modal-header-app"
      >
        <Modal.Title>
          <span className="modal-title-app">{t.instellingen}</span>
        </Modal.Title>
      </Modal.Header>

      <Modal.Body className="body_settings">
        <Card className="card-app">
          <CardHeader className="card-header-app">
            <Nav
              className="card_settings-nav"
              activeKey={selectedView}
              onSelect={handleSelect}
            >
              <Nav.Item>
                <Nav.Link className="nav-link-app" eventKey="Installateur">
                  {t.installateur}
                </Nav.Link>
              </Nav.Item>
              <Nav.Item>
                <Nav.Link className="nav-link-app" eventKey="Klant">
                  {t.klant}
                </Nav.Link>
              </Nav.Item>
              <Nav.Item>
                <Nav.Link className="nav-link-app" eventKey="Opties">
                  {t.opties}
                </Nav.Link>
              </Nav.Item>
            </Nav>
          </CardHeader>

          <CardBody className="card-body-app">
            {selectedView === "Installateur" && <Klantgegevens />}
            {selectedView === "Klant" && <EindkKlantgegevens />}
            {selectedView === "Opties" && <SettingsOptions />}
          </CardBody>
        </Card>
      </Modal.Body>
    </Modal>
  );
};

export default Settings;
